import actions from './actions';

const initState = {
    checkStatusLoading: false,
    checkStatusError: null,
    checkStatusResult: {},

    checkDataUsageLoading: false,
    checkDataUsageError: null,
    checkDataUsageResult: [],
}

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.CHECK_STATUS:
            return {
                ...state,
                checkStatusLoading: true,
                checkStatusError: null,
                checkStatusResult: {},
            };
        case actions.CHECK_STATUS_SUCCESS:
            return {
                ...state,
                checkStatusLoading: false,
                checkStatusResult: action.payload.data,
                checkStatusError: null,
            }
        case actions.CHECK_STATUS_FAILED:
            return {
                ...state,
                checkStatusLoading: false,
                checkStatusError: action.payload.error,
            };

        case actions.RESET_MESSAGE:
            return {
                ...state,
                checkStatusError: null,
                checkStatusResult: {},
                checkDataUsageResult: [],
                checkDataUsageError: null,
            };

        case actions.CHECK_DATA_USAGE:
            return {
                ...state,
                checkDataUsageLoading: true,
                checkDataUsageError: null,
                checkDataUsageResult: [],
            };
        case actions.CHECK_DATA_USAGE_SUCCESS:
            return {
                ...state,
                checkDataUsageLoading: false,
                checkDataUsageResult: action.payload.data,
                checkDataUsageError: null,
            }
        case actions.CHECK_DATA_USAGE_FAILED:
            return {
                ...state,
                checkDataUsageLoading: false,
                checkDataUsageError: action.payload.error,
            };

        default:
            return state;
    }
}
